var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldEmojiSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CC1C917B-8326-4A34-BDE6-0BD82D3F18A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-556.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emoji-sad",
    transform: "translate(556.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80999994,2 C4.16999984,2 2,4.16999984 2,7.80999994 L2,16.1800003 C2,19.8300004 4.16999984,22 7.80999994,22 L16.1800003,22 C19.8200004,22 21.9900341,19.8300006 21.9900341,16.1900005 L21.9900341,7.80999994 C22,4.16999984 19.8300006,2 16.1900005,2 L7.80999994,2 Z M6.46999979,8.22000027 C7.75999975,6.93000031 9.87000012,6.93000031 11.1700001,8.22000027 C11.4600001,8.51000026 11.4600001,8.98999974 11.1700001,9.27999973 C11.0200001,9.42999974 10.8300003,9.5 10.6400003,9.5 C10.4500003,9.5 10.2599997,9.42999974 10.1099997,9.27999973 C9.39999968,8.56999975 8.24000019,8.56999975 7.53000021,9.27999973 C7.24000022,9.57999974 6.75999978,9.57999974 6.46999979,9.27999973 C6.1799998,8.98999974 6.1799998,8.51000026 6.46999979,8.22000027 Z M8.39999962,18.0799999 C7.69999963,18.0799999 7.13000011,17.5099992 7.13000011,16.7999992 C7.13000011,14.1099992 9.32000017,11.9200001 12.0100002,11.9200001 C14.7000003,11.9200001 16.8899994,14.1099992 16.8899994,16.7999992 C16.8799994,17.5 16.3000004,18.0799999 15.6000004,18.0799999 L8.39999962,18.0799999 Z M16.4699993,9.27999973 C15.7599993,8.56999975 14.6000003,8.56999975 13.8900003,9.27999973 C13.7400003,9.42999974 13.5499997,9.5 13.3599997,9.5 C13.1699997,9.5 12.9799999,9.42999974 12.8299999,9.27999973 C12.5399999,8.98999974 12.5399999,8.51000026 12.8299999,8.22000027 C14.1199999,6.93000031 16.2300007,6.93000031 17.5300007,8.22000027 C17.8200007,8.52000028 17.8200007,8.98999974 17.5300007,9.27999973 C17.2400007,9.56999972 16.7599993,9.56999972 16.4699993,9.27999973 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldEmojiSad);
export default __webpack_public_path__ + "static/media/vuesax-bold-emoji-sad.80856051a7aae000701ad2c1d8e310be.svg";
export { ForwardRef as ReactComponent };